import React from 'react';
import {useLocale} from '../../Localization/LocaleContext';

const TextInput = ({placeholder, type, onChangeText, value}) => {
  const {translate} = useLocale();
  return (
    <input
      type={type}
      placeholder={translate(placeholder)}
      value={value}
      onChange={e => onChangeText(e.target.value)}
      className="w-full border  rounded-md  border-gray-300"
    />
  );
};

export default TextInput;
